module.exports = __webpack_public_path__ + "img/hatul_yes.67f14de9.png";